<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemDictionaryDialog',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" :centered="true" :wrap-class-name="'wrap-dictionary-dialog'"
    :closable="false" :maskClosable="false" :title="state.dialog.title" :width="state.dialog.width" :keyboard="false"
    :confirm-loading="state.loading.submit" :ok-text="state.dialog.submitTxt" @ok="onSubmit" @cancel="closeDialog">
    <div class="form-content">
      <a-form ref="formRef" :model="state.ruleForm" :rules="state.rules">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="字典名称" name="name">
              <a-input showCount v-model:value="state.ruleForm.name" placeholder="请输入字典名称" :maxlength="20"
                allow-clear />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="字典编码" name="code">
              <a-input showCount v-model:value="state.ruleForm.code" placeholder="请输入字典编码" :maxlength="20"
                allow-clear />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="描述" name="note" class="note-item">
          <a-textarea v-model:value="state.ruleForm.note" placeholder="请输入描述" :maxlength="100" :rows="4" allow-clear
            show-count />
        </a-form-item>
      </a-form>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="systemDictionaryDialog">
import { reactive, ref, nextTick } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message } from 'ant-design-vue'
import { useDictionary } from '@/store/system/dictionary'
const dictionaryStore = useDictionary()

const emit = defineEmits(['createUpdate'])

const formRef = ref()

const emptyForm = {
  id: '',
  name: '',
  code: '',
  note: ''
}

const state = reactive({
  ruleForm: cloneDeep(emptyForm),
  rules: {
    name: [{ required: true, message: '请输入字典名称', trigger: 'blur' }],
    code: [{ required: true, message: '请输入字典编码', trigger: 'blur' }],
    note: [{ required: false, message: '请输入描述', trigger: 'blur' }]
  },
  viewType: '',
  dialog: {
    visible: false,
    title: '',
    submitTxt: '',
    width: '645px'
  },
  loading: {
    submit: false
  }
})

const openDialog = (type: string, row: any) => {
  state.viewType = type
  state.dialog.visible = true
  nextTick(() => {
    if (type === 'edit') {
      state.ruleForm = cloneDeep(row)
      state.dialog.title = '修改字典'
      state.dialog.submitTxt = '修改'
    } else if (type === 'detail') {
      state.ruleForm = cloneDeep(row)
      state.dialog.title = '字典详情'
      state.dialog.submitTxt = '关闭'
    } else {
      state.ruleForm = cloneDeep(emptyForm)
      state.dialog.title = '新增字典'
      state.dialog.submitTxt = '确认'
    }
  })
}

const closeDialog = () => {
  state.dialog.visible = false
  state.loading.submit = false
  state.ruleForm = cloneDeep(emptyForm)
  formRef.value?.resetFields()
}

const onSubmit = () => {
  formRef.value
    .validate()
    .then(async () => {
      try {
        state.loading.submit = true
        if (state.viewType === 'add') {
          await dictionaryStore.addDict(state.ruleForm)
          message.success('新增字典成功')
        } else {
          await dictionaryStore.updateDict(state.ruleForm)
          message.success('修改字典成功')
        }
        state.loading.submit = false
        emit('createUpdate', state.viewType, cloneDeep(state.ruleForm))
      } catch (error) {
        state.loading.submit = false
        // console.error(error)
        // message.error('操作失败')
      }
    })
    .catch(() => {
      state.loading.submit = false
    })
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 30px 36px 16px 36px;
}

// ===== 表单 =====
:deep(.ant-form-item) {
  margin-bottom: 0px;
  padding-bottom: 16px;
}

:deep(.ant-form-item-label) {
  margin-left: 0px;
  margin-right: 5px;
  width: 80px;
  text-align: right;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  height: 40px;
}

:deep(.ant-form-item-label > label) {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
}

:deep(.ant-input-affix-wrapper) {
  height: 40px;
  padding: 0 11px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}

//textarea样式====>
:deep(.ant-input-affix-wrapper:has(textarea)) {
  height: auto !important;
  min-height: 40px;
}

:deep(textarea.ant-input) {
  min-height: 198px;
  resize: vertical;
  border-radius: 4px;
  padding: 8px 22px 8px 11px;
}

:deep(.note-item .ant-input-textarea) {
  position: relative;
  display: inline-block;
  width: 100%;

  &[data-count]::after {
    content: attr(data-count);
    position: absolute;
    right: 10px;
    bottom: 5px;
    z-index: 1;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    pointer-events: none;
    background: #fff;
    padding-left: 4px;
    line-height: 1;
  }
}

:deep(.ant-input-data-count) {
  display: none;
}

// 仅 textarea 的清除图标需要固定到第一行，普通 a-input 保持默认 flex 布局避免 x 与 count 重叠
:deep(.ant-input-textarea .ant-input-clear-icon) {
  position: absolute;
  top: 12px;
  right: 10px;
  bottom: auto;
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  line-height: 1;
}

//<====textarea样式

.space-divider {
  height: 1px;
  background: #A0B8E5;
}
</style>
